export default {
  Resume: {
    full_name: {
      prev: null,
      next: 'tagline',
    },
    tagline: {
      prev: 'fullName',
      next: 'email',
    },
    email: {
      prev: 'tagline',
      next: 'phoneNumber',
    },
    phone_number: {
      prev: 'email',
      next: 'address',
    },
    address: {
      prev: 'phoneNumber',
      next: 'personalLinks',
    },
    personal_link: {
      prev: 'address',
      next: 'objective',
    },
    objective: {
      prev: 'personalLinks',
      next: null,
    },
  },
  'Cover Letter': {
    receiver_name: {
      prev: null,
      next: 'letterDate',
    },
    letter_date: {
      prev: 'receiverName',
      next: 'receiverTagline',
    },
    receiver_tagline: {
      prev: 'letterDate',
      next: 'receiverOrganization',
    },
    receiver_organization: {
      prev: 'receiverTagline',
      next: 'receiverAddress',
    },
    receiver_address: {
      prev: 'receiverOrganization',
      next: 'subjectLine',
    },
    subject_line: {
      prev: 'receiverAddress',
      next: 'openGreeting',
    },
    open_greeting: {
      prev: 'subjectLine',
      next: 'letterBody',
    },
    letter_body: {
      prev: 'openGreeting',
      next: 'closeGreeting',
    },
    close_greeting: {
      prev: 'letterBody',
      next: 'senderName',
    },
    sender_name: {
      prev: 'closeGreeting',
      next: 'senderTagline',
    },
    sender_tagline: {
      prev: 'senderName',
      next: 'senderEmail',
    },
    sender_email: {
      prev: 'senderTagline',
      next: 'senderPhoneNumber',
    },
    sender_phone_number: {
      prev: 'senderEmail',
      next: 'senderAddress',
    },
    sender_address: {
      prev: 'senderPhoneNumber',
      next: 'personalLinks',
    },
    personal_link: {
      prev: 'senderAddress',
      next: null,
    },
  },
};
export const TabRestrictedInput = ['phoneNumber', 'senderPhoneNumber'];
